/** @format */

import { Injectable } from "@angular/core";
import Swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class AlertService {
  constructor() {}

  //완료 메세지
  successmsg(text: string, title = "") {
    return Swal.fire({
      title,
      text,
      icon: "success",
      confirmButtonText: "확인",
      customClass: {
        confirmButton: "btn btn-success swal-alert-btn",
      },
    });
  }
  //에러 메세지
  errormsg(text: string, title = "") {
    return Swal.fire({
      title,
      text,
      icon: "error",
      confirmButtonText: `닫기`,
      customClass: {
        confirmButton: "btn btn-success swal-alert-btn",
      },
    });
  }

  //긍정적 컴펌 메세지
  successConfirm(text, confirmButtonText = "확인", title = "") {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title,
        text,
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        customClass: {
          confirmButton: "swal-alert-btn",
          cancelButton: "swal-alert-btn",
        },
        confirmButtonText,
        cancelButtonText: "취소",
        reverseButtons: true,
      })
        .then((result) => {
          if (result.value) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // 부정적 컴펌 메세지
  warningConfirm(text, confirmButtonText = "확인", title = "") {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title,
        text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        customClass: {
          confirmButton: "swal-alert-btn",
          cancelButton: "swal-alert-btn",
        },
        confirmButtonText,
        cancelButtonText: "닫기",
      })
        .then((result) => {
          if (result.value) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // 푸시 메시지 입력
  async inputPushMessage(
    title: string = "푸시 메시지 입력",
    placeholder: string = "메시지를 입력하세요"
  ): Promise<string | null> {
    const { value: message } = await Swal.fire({
      title,
      input: "textarea",
      inputPlaceholder: placeholder,
      inputAttributes: {
        "aria-label": "푸시 메시지를 입력하세요",
        maxlength: "500",
        rows: "4",
      },
      showCancelButton: true,
      confirmButtonText: "전송",
      cancelButtonText: "취소",
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#f46a6a",
      customClass: {
        confirmButton: "swal-alert-btn",
        cancelButton: "swal-alert-btn",
      },
      inputValidator: (value) => {
        if (!value || value.trim() === "") {
          return "메시지를 입력해주세요!";
        }
        if (value.length > 500) {
          return "메시지는 500자 이내로 입력해주세요!";
        }
        return null;
      },
    });

    return message;
  }

  //토스트
  swalToast(title, icon?) {
    Swal.fire({
      toast: true,
      timerProgressBar: true,
      position: "bottom",
      icon: icon ? icon : "success",
      title,
      showConfirmButton: false,
      timer: 2000,
    });
  }

  //이미지 얼럿
  imageHeader(title, text, imageUrl, imageHeight) {
    Swal.fire({
      title,
      text,
      imageUrl,
      imageHeight,
      confirmButtonColor: "#556ee6",
    });
  }

  //타이머 strong 태그안에 시간이 들어가도록 세팅해주세요.
  timer(title, html) {
    let timerInterval;

    Swal.fire({
      title,
      html,
      timer: 2000,
      didOpen: () => {
        Swal.showLoading();
        timerInterval = setInterval(() => {
          Swal.getContainer().querySelector("strong").textContent =
            Swal.getTimerLeft() + "";
        }, 100);
      },
      willClose: () => {
        clearInterval(timerInterval);
      },
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer) {
      }
    });
  }
}
